module.exports = require("@swa-ui/dotcom/src/DesktopHeaderControl/CtmInformation.module.scss");